<template>
  <div class="inputfiles-container">
    <div v-for="(file, index) in modelValue" :key="index">
      <template v-if="!file.is_delete">
        <download-file
          v-model="modelValue[index]"
          :name="inputName(index)"
          :input-name="inputName"
          :name-label="nameLabel"
          :base-url="baseUrl"
          :error="file.error"
          @download:modelValue="download"
          @open:modelValue="open">
        </download-file>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DownloadFile from './DownloadFile.vue'

export default defineComponent({
  props:['modelValue', 'name', 'inputName', 'nameLabel', 'baseUrl'],
  setup(props, context) {
    /**
     * INPUTタグのNAME属性を返します
     * @param idx
     */
    const inputName = (idx: number) => {
      return props.name + idx
    }

    const download = (value: any) => {
      context.emit('download:modelValue', value)
    }

    const open = (value: any) => {
      context.emit('open:modelValue', value)
    }

    return {
      inputName,
      download,
      open
    }
  },
  components: {
    'download-file': DownloadFile
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/form/input-files.scss';
</style>
